export default "__VITE_ASSET__CrbarplU__"